// extracted by mini-css-extract-plugin
export var bgClass = "LeftTextWithRightBox-module--bgClass--ggQO1";
export var linkText = "LeftTextWithRightBox-module--linkText--MMjmC";
export var line = "LeftTextWithRightBox-module--line--sNdSo";
export var smallImages = "LeftTextWithRightBox-module--smallImages--nl0Nn";